import React, {Component} from 'react';
import PropTypes from 'prop-types';
import media from '../MediaQueries.js';
import styled from 'styled-components';
import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownMenu, ButtonDropdown, DropdownItem, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';


export default class ShopDropdownSort extends Component {
  static propTypes = {
    selectDropdownItem: PropTypes.func.isRequired,
    toggleDropdownOpen: PropTypes.func.isRequired,
    dropdownOpen: PropTypes.bool.isRequired,
    dropdownValue: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    const SortDropdownSort = (
      <SortDiv>
        <span>Sort by</span>
        <SortDropdown isOpen={this.props.dropdownOpen} toggle={this.props.toggleDropdownOpen}>
          <DropdownToggle caret>
            {this.props.dropdownValue}
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={this.props.selectDropdownItem}>Relevance</DropdownItem>
            <DropdownItem onClick={this.props.selectDropdownItem}>Price (low to high)</DropdownItem>
            <DropdownItem onClick={this.props.selectDropdownItem}>Price (high to low)</DropdownItem>
            <DropdownItem onClick={this.props.selectDropdownItem}>Date (newest first)</DropdownItem>
            <DropdownItem onClick={this.props.selectDropdownItem}>Alphabetical (A-Z)</DropdownItem>
          </DropdownMenu>
        </SortDropdown>
      </SortDiv>
    );

    return (
      <FluidContainer className="p-0" fluid>
          {SortDropdownSort}
      </FluidContainer>
    );
  }
}

const SortDiv = styled.div`
  text-align: right; 

  span {
    font-size: 15px;
    margin: 0 8px 0 0;
    ${media.sm` font-size: 16px; `}
  }
`;

const SortDropdown = styled(ButtonDropdown)`
  display: inline;
  
  button {
    font-family: "Raleway";
    font-size: 14px;
    text-align: left;
    width: 220px;

    ${media.sm` font-size: 16px; width: 250px; `}
  }
`;

const FluidContainer = styled(Container)`  `;
/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/components/ShopDropdownSort.js